<template>
	<v-container :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'px-5 py-0': $vuetify.breakpoint.mdAndUp}">
		<v-layout row wrap>
			<!-- Boton en mobile para avanzar -->
			<v-layout v-if="$vuetify.breakpoint.smAndDown" justify-end>
				<v-btn
					color="#1f97b9"
					@click="validate(true, 'Mudanza_Paso_2', $vuetify.breakpoint.mdAndUp)"
					dark
				>
					Cotizar
				</v-btn>
			</v-layout>
			<!-- fin de boton -->
			<v-flex md5 sm5 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}">
				<v-layout row wrap>
					<v-flex xs12 px-0 class="search-element-container" ref="searchContainer" :style="{height: searchContainerHeight + 64 +'px'}">
						<v-text-field
			        class="mx-0 barra-busqueda"
			        flat
			        label="Buscar elemento"
			        background-color="#1f97b9"
			        height="64px"
			        dark
			        color="white"
			        solo-inverted
			        hide-details
			        v-model="searchInput"
			        @keyup="searchedElement"
			      >
			      	<img :src='require("../../../assets/static/img/search.png")'  alt="icono de lupa" style="width: 30px;height:30px;" slot="prepend-inner">
			      </v-text-field>
            <v-btn class="btn-close-pago-dialog" dark icon v-show="showSearch" @click="closeSearch()">
              <v-img :src='require("../../../assets/static/img/cerrar.png")'  alt="icono de cerrar ventana" max-height="25" contain></v-img>
            </v-btn>
						<v-list two-line id="list-suggestions" class="list-suggestion" v-show="showSearch" ref="searchResultContainer">
		          <template v-for="(item, index) in searchElements">
		            <v-list-tile
		              :key="'sf-' + index"
		              ripple
		            >
									<v-list-tile-content class="title-elements-list-title">
										<v-img
											:src='item.img'
											max-height="40"
											max-width="40"
											class="mr-2"
											contain
										></v-img>
										<v-list-tile-title style="height:auto;line-height: 15px;">
											<small>{{ item.cat }}</small><br/>
											{{ item.nombre }}
										</v-list-tile-title>
										<v-tooltip right max-width="300px">
												<template slot="activator">
													<v-layout align-center>
														<img
															:src='require("../../../assets/static/img/info.png")'
															alt="icono de info"
															class="ml-2"
															width="16px"
															height="16px"
															contain
														/>
													</v-layout>
												</template>
								        <span>{{item.descripcion}}</span>
								    </v-tooltip>
									</v-list-tile-content>

		              <v-list-tile-action class="actions-element-search">
<!-- 										<v-layout align-center>
											<v-text-field
												v-if="showSearch"
												:ref="'s-' + index"
												color="#1f97b9"
												class="input-qty-second"
												type="number"
												style="width: 30px;"
												@input="addElementbySearch('s-' + index)"
												:min="0"
											></v-text-field>
										</v-layout> -->
										<v-btn color="#1f97b9" style="max-width:30px;max-height:30px;" fab small dark @click="minusElementbySearch('s-' + index)">
											<v-icon small>fas fa-minus</v-icon>
										</v-btn>
										<p v-if="showSearch" :ref="'s-' + index" class="qty-input-select-element">0</p>
										<v-btn color="#1f97b9" style="max-width:30px;max-height:30px;" fab small dark @click="plusElementbySearch('s-' + index)">
											<v-icon small>fas fa-plus</v-icon>
										</v-btn>
		              </v-list-tile-action>

		            </v-list-tile>
		            <v-divider
		              v-if="index + 1 < searchElements.length"
		              :key="'div-' + index"
		            ></v-divider>
		          </template>
		        </v-list>

					</v-flex>
				</v-layout>
				<v-expansion-panel>
					<v-expansion-panel-content
						v-for="(el, i) in elementos"
						style="background-color: #1f97b9;"
						:key="i"
						class="custom-expansion-panel-td mb-1"
						hide-actions
						ripple
						lazy
					>
						<div slot="header" @click="test($event)">
							<v-layout row wrap align-center class="background-duo">
								<v-flex md2 sm2 xs2 py-1 align-center justify-center class="text-xs-center container-nombre-categoria">
									<h3 class="font-weight-bold white--text nombre-categoria">{{ el.datos.nombre }}</h3>
								</v-flex>
								<v-flex md10 sm10 xs10 align-center justify-center class="icon-nombre-categoria">
									<v-img
										class="link mx-auto my-3 img-icon-categoria"
										alt="icono de categoria"
										:src='el.datos.img'
										max-height="80"
										contain
									></v-img>
								</v-flex>
							</v-layout>
						</div>
						<v-icon slot="actions" color="white" class="mr-3">fas fa-caret-down</v-icon>
						<v-card>
							<v-card-text class="grey lighten-3" style="color: black">
								<v-list class="grey lighten-3 listado-elementos elements-second" style="color: black;" dense>
									<v-list-tile
										v-for="(els, index) in el.elementos"
										:class="{'grey lighten-2' : index % 2 !== 0}"
										:key="index"
									>
										<v-list-tile-content class="title-elements-list-title">
											<v-img
												:src='els.img'
												max-height="40"
												max-width="40"
												class="mr-2"
												contain
											></v-img>
											<v-list-tile-title v-text="els.nombre"></v-list-tile-title>
											<v-tooltip right max-width="300px">
													<template slot="activator">
														<v-layout align-center>
															<img
																:src='require("../../../assets/static/img/info.png")'
																alt="icono de informacion"
																class="ml-2"
																width="16px"
																height="16px"
																contain
															/>
														</v-layout>
													</template>
									        <span>{{els.descripcion}}</span>
									    </v-tooltip>
										</v-list-tile-content>

										<v-list-tile-action class="elements-actions-second">
											<v-layout align-center>
<!-- 												<v-text-field
													:ref="i + '-' + index"
													color="#1f97b9"
													class="input-qty-second"
													type="number"
													style="width: 30px;"
													@input="addElement(i + '-' + index)"
													:min="0"
												></v-text-field> -->
												<v-btn color="#1f97b9" style="max-width:30px;max-height:30px;" fab small dark @click="minusElement(i + '-' + index)">
													<v-icon small>fas fa-minus</v-icon>
												</v-btn>
												<p :ref="i + '-' + index" class="qty-input-select-element">0</p>
												<v-btn color="#1f97b9" style="max-width:30px;max-height:30px;" fab small dark @click="plusElement(i + '-' + index)">
													<v-icon small>fas fa-plus</v-icon>
												</v-btn>
											</v-layout>
										</v-list-tile-action>

									</v-list-tile>
								</v-list>
							</v-card-text>
						</v-card>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-flex>
			<!-- <v-flex md7 sm7 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}"> -->
			<v-flex md7 sm7 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}">
				<div style="height:1px" class="viewport-fix" v-in-viewport></div>
				<!-- <div class="elements-container-full" v-in-viewport @click="scrollToELements()"> -->
					<div class="elements-container-full" v-in-viewport>
					<v-toolbar v-if="$vuetify.breakpoint.mdAndUp" color="#1f97b9" dark class="item-qty-container">
						<img :src='require("../../../assets/static/img/clipboard.png")' alt="icono de datos" style="width: 30px;">
						<v-toolbar-title class="texto-listado-articulos-sel">Artículos a Transportar</v-toolbar-title>
					</v-toolbar>
					<!-- <v-toolbar v-if="selectedElements.length > 0" color="#1f97b9" dark class="item-qty-container">
						<v-toolbar-title class="texto-listado-articulos-embalaje">
							<v-list-tile-action>
								<v-checkbox
									on-icon="far fa-check-square"
									off-icon="far fa-square"
									color="primary"
									v-model="embalaje"
									label="Embalar todo"
									id="embalajeTodo"
									@change="setEmbalajeTotal(true)"
									hide-details
									persistent-hint
								>Embalaje</v-checkbox>
							</v-list-tile-action>
						</v-toolbar-title>
						<v-toolbar-title class="texto-listado-articulos-embalaje">
							  Embalaje
						</v-toolbar-title>
					</v-toolbar> -->
					<v-toolbar v-if="selectedElements.length > 0" color="#1f97b9" dark class="item-qty-container">
						<!-- <v-toolbar-title class="texto-listado-articulos-embalaje">
							<v-list-tile-action>
								<v-checkbox
									on-icon="far fa-check-square"
									off-icon="far fa-square"
									color="primary"
									v-model="embalaje"
									label="Todo por escalera"
									id="embalajeTodo"
									@change="setEscaleraTotal(true)"
									hide-details
									persistent-hint
								>Embalaje</v-checkbox>
							</v-list-tile-action>
						</v-toolbar-title> -->
						<v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp" class="texto-listado-articulos-sel">Seleccione las cosas que <br> van por Escalera</v-toolbar-title>
						<v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp" class="texto-listado-articulos-embalaje"/>
						<v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp" class="texto-listado-articulos-embalaje">
							  Origen
							  <v-list-tile-action>
								<v-checkbox
									on-icon="far fa-check-square"
									off-icon="far fa-square"
									color="primary"
									v-model="embalajeOrigen"
									id="embalajeTodo"
									@change="setEscaleraTotal('origen')"
									hide-details
									persistent-hint
								>Embalaje</v-checkbox>
							</v-list-tile-action>
						</v-toolbar-title>
						<v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp" style="right: 50px" class="texto-listado-articulos-embalaje">
							  Destino
							  <v-list-tile-action>
									<v-checkbox
										on-icon="far fa-check-square"
										off-icon="far fa-square"
										color="primary"
										v-model="embalajeDestino"
										id="embalajeTodo"
										@change="setEscaleraTotal('destino')"
										hide-details
										persistent-hint
									>Embalaje</v-checkbox>
								</v-list-tile-action>
						</v-toolbar-title>
					</v-toolbar>
					<v-card>
						<v-card-text class="grey lighten-3" style="color: black">
							<v-list class="grey lighten-3 listado-elementos listado-seleccionados" style="color: black;" dense>
								<v-list-tile
									v-for="(els, index) in selectedElements"
									:class="{'grey lighten-2' : index % 2 !== 0}"
									:key="index"
								>
									<v-list-tile-avatar>
										<v-badge color="#1f97b9">
											<span slot="badge">{{els.qty}}</span>
										</v-badge>
									</v-list-tile-avatar>
									<v-list-tile-content class="title-elements-list-title">
										<v-img
											:src='els.img'
											max-height="40"
											max-width="40"
											class="mr-2"
											contain
										></v-img>
										<v-list-tile-title v-text="els.nombre"></v-list-tile-title>
									</v-list-tile-content>
									<!-- <v-list-tile-action>
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											color="primary"
											hint="¿Requiere servicio de embalaje para este elemento?"
											v-model="els.embalaje"
											id="embalajeIndividual"
											hide-details
											persistent-hint
										>Embalaje</v-checkbox>
									</v-list-tile-action> -->
									<v-list-tile-action v-if="$vuetify.breakpoint.mdAndUp">
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											color="primary"
											hint="¿Requiere servicio de embalaje para este elemento?"
											v-model="els.escaleraO"
											id="embalajeIndividual"
											hide-details
											persistent-hint
										>Escalera</v-checkbox>
									</v-list-tile-action>
									<v-list-tile-action v-if="$vuetify.breakpoint.mdAndUp">
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											color="primary"
											hint="¿Requiere servicio de embalaje para este elemento?"
											v-model="els.escaleraD"
											id="embalajeIndividual"
											hide-details
											persistent-hint
										>Escalera</v-checkbox>
									</v-list-tile-action>
									<v-list-tile-action>
										<v-btn style="max-width:30px;max-height:30px;" color="#1f97b9" fab small dark @click="removeElement(index)">
											<v-icon small>fas fa-minus</v-icon>
										</v-btn>
									</v-list-tile-action>
								</v-list-tile>
							</v-list>
						</v-card-text>
					</v-card>
					<v-toolbar v-if="$vuetify.breakpoint.mdAndUp" color="#1f97b9" dark class="item-qty-container">
						<v-toolbar-title class="texto-listado-articulos-sel" @click="validate(true, 'Mudanza_Paso_2', $vuetify.breakpoint.mdAndUp)">Total Articulos<span>{{totalElements}}</span></v-toolbar-title>
						<span>{{counterVolume}}m³</span>
					</v-toolbar>
					<v-toolbar v-else-if="$vuetify.breakpoint.smAndDown && searchInput === '' && !dialogEscalera" color="#1f97b9" dark class="item-qty-container">
						<v-toolbar-title class="texto-listado-articulos-sel" @click="validate(true, 'Mudanza_Paso_2', $vuetify.breakpoint.mdAndUp)">Cotizar<span>{{totalElements}}</span></v-toolbar-title>
						<span>{{counterVolume}}m³</span>
					</v-toolbar>

					<v-layout justify-end>
						<v-btn
							color="grey"
							dark
							@click="goBack"
						>
							Volver
						</v-btn>
						<v-btn
							color="#1f97b9"
							@click="validate(true, 'Mudanza_Paso_2', $vuetify.breakpoint.mdAndUp)"
							dark
						>
							Cotizar
						</v-btn>
					</v-layout>
				</div>

			</v-flex>
			<v-dialog v-model="dialogEscalera" max-width="800" persistent>
				<v-card>
					<v-toolbar card dark color="#1f97b9">
						<v-toolbar-title>Elementos por escalera</v-toolbar-title>
					</v-toolbar>
					<v-card-text>
						<p>¿Hay elementos que se tengan que transportar por escalera en el origen o en el destino?</p>
						<v-list-tile-action>
							<v-checkbox
								on-icon="far fa-check-square"
								off-icon="far fa-square"
								label="Origen"
								color="primary"
								hint="Origen"
								v-model="escaleraMobileOrigen"
								id="embalajeIndividual"
								hide-details
								persistent-hint
							>Escalera</v-checkbox>
						</v-list-tile-action>
						<v-list-tile-action>
							<v-checkbox
								on-icon="far fa-check-square"
								off-icon="far fa-square"
								label="Destino"
								color="primary"
								hint="Destino"
								v-model="escaleraMobileDestino"
								id="embalajeIndividual"
								hide-details
								persistent-hint
							>Escalera</v-checkbox>
						</v-list-tile-action>
					</v-card-text>
					<v-list v-if="escaleraMobileDestino || escaleraMobileOrigen">
						<v-list-tile  v-for="(els, index) in selectedElements" :class="{'grey lighten-2' : index % 2 !== 0}" :key="index">
							<v-list-tile-title v-text="els.nombre"></v-list-tile-title>
							<v-list-tile-action v-show="escaleraMobileOrigen">
								<v-checkbox
									on-icon="far fa-check-square"
									off-icon="far fa-square"
									label="O"
									color="primary"
									hint="O"
									v-model="els.escaleraO"
									id="embalajeIndividual"
									hide-details
									persistent-hint
								>Escalera</v-checkbox>
							</v-list-tile-action>
							<v-list-tile-action v-show="escaleraMobileDestino">
								<v-checkbox
									on-icon="far fa-check-square"
									off-icon="far fa-square"
									label="D"
									color="primary"
									hint="D"
									v-model="els.escaleraD"
									id="embalajeIndividual"
									hide-details
									persistent-hint
								>Escalera</v-checkbox>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>
					
					<v-layout justify-end>
						<v-btn
							color="#1f97b9"
							@click="preValidateStairs(true, 'Mudanza_Paso_2', true)"
							dark
						>
							Cotizar
						</v-btn>
					</v-layout>
				</v-card>
			</v-dialog>
		</v-layout>
	</v-container>
</template>

<script>
	import { EventBus } from '../../../events.js'
	import * as firebase from 'firebase/app'
	import 'firebase/firestore'
	import * as ScrollToElement from 'scroll-to-element'
	export default {
		name: 'mudanzaSecond',
		data () {
			return {
				elementos: [],
				manualElement: {},
				element_manual: {},
				totalSearchElements: [],
				searchElements: [],
				searchInput: '',
				showSearch: false,
				selectedElements: [],
				totalElements: 0,
				datos:{},
				counterVolume: 0,
				searchContainerHeight: 0,
				rules: {
					required: [ v => !!v || 'Campo obligatorio' ]
				},
				embalajeOrigen: false,
				embalajeDestino: false,
				dialogEscalera: false,
				escaleraMobileDestino: false,
				escaleraMobileOrigen: false,
				selectedStairs: false
			}
		},
		methods: {
			preValidateStairs() {
				//verificar si hay uno o mas elementos seleccionados con escalera, en caso de haber uno o mas, se cambia 
				// selectedStairs a verdadero y continua el flujo
				const here = this
				this.selectedElements.forEach(function(elemento) {
					if (elemento.escaleraD || elemento.escaleraO) {
						here.selectedStairs = true
					}
				})
				if (!this.escaleraMobileDestino && !this.escaleraMobileOrigen) {
					this.validate(true, 'mobileStairs', true)	
				} else if (this.selectedStairs) {
					this.validate(true, 'mobileStairs', true)
				}
			},
			validate (move = true, event = '', normalSize) {
				// Se agregó un parámetro a la función validate, para indicarle si debe moverse o no (así salta directo al paso que se necesite)
				// Si no se envía el parámetro move toma valor true
				console.log(normalSize)
				if (normalSize) {
					this.dialogEscalera = false
					if (event !== '') {
						this.eventTracker(event)
					}
					var data = {
						datos: this.selectedElements,
						qty: this.totalElements,
						valid: true,
						move
					}
					if (this.selectedElements.length > 0) {
						EventBus.$emit('mudanzaSecond', data);
					}
					else{
						data.valid = false
						EventBus.$emit('mudanzaSecond', data);
						this.control = false
					}	
				} else {
					this.dialogEscalera = true
					console.log('Ahora se tiene que desplegar el dialog')
				}
				
			},
			closeSearch() {
				this.showSearch = false
				this.searchInput = ''
			},
			setEscaleraTotal(tipo) {
				const here = this
				if (tipo === 'origen') {
					if (this.selectedElements.length > 0) {
						this.selectedElements.forEach(function(elemento) {
							elemento.escaleraO = here.embalajeOrigen
						})
					}
				} else if (tipo === 'destino') {
					if (this.selectedElements.length > 0) {
						this.selectedElements.forEach(function(elemento) {
							elemento.escaleraD = here.embalajeDestino
						})
					}
				}
					
				
			},
			checkEmbalajeTotal(embalajeElemento) {
				if (!embalajeElemento) {
					this.embalaje = false
				}
			},
			setEmbalajeTotal(change) {
				const here = this
				if (change) {
					if (this.selectedElements.length > 0) {
						this.selectedElements.forEach(function(elemento) {
							elemento.embalaje = here.embalaje
						})
					}
				}
			},
			test(e){
				const parent = e.target.closest("li.v-expansion-panel__container")
				const searched = parent.querySelector('.v-expansion-panel__body .v-card')
				const here = this
				if(searched === null){
					setTimeout(function(){ here.test(e) }, 200);
				}
				else{
					setTimeout(function(){ here.scrollTo(e) }, 500);
				}
			},
			scrollToELements(){
				if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
					const element = document.querySelector('.listado-seleccionados')
					ScrollToElement(element,{
					    offset: -120,
					    ease: 'in-out-sine',
					    duration: 700
					})
				}
			},
			scrollTo(element){
				ScrollToElement(element.target,{
				    offset: -20,
				    ease: 'in-out-sine',
				    duration: 700
				})				
			},
			searchedElement(){
				const self = this
				this.searchElements = this.totalSearchElements.filter(function(el){
					if(
						el.nombre.toLowerCase().search(self.searchInput.toLowerCase()) !== -1 ||
						el.descripcion.toLowerCase().search(self.searchInput.toLowerCase()) !== -1
					){
						return true
					}
					else{return false}
				})
				if(this.searchInput.length > 2){
					this.showSearch = true
				}
				else{ this.showSearch = false }
			},
			plusElement(el){
				let qty = parseInt(this.$refs[el][0].innerText)
				qty++
				this.$refs[el][0].innerText = qty
				if(qty || qty == ''){
					let indexes = el.split("-")
					let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
					let newObjectElement = Object.assign( newElement, this.elementos[indexes[0]].elementos[indexes[1]] )
					var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
					if(foundIndex != -1){
						this.selectedElements[foundIndex].qty = newObjectElement.qty
						if(newObjectElement.qty == 0){
							this.selectedElements.splice(foundIndex,1)
						}
					}
					else{
						this.selectedElements.push(newObjectElement)
					}
					this.countElements()
				}
			},
			minusElement(el){
				let qty = parseInt(this.$refs[el][0].innerText)
				if(qty > 0){
					qty--
					this.$refs[el][0].innerText = qty
					if(qty || qty == ''){
						let indexes = el.split("-")
						let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
						let newObjectElement = Object.assign( newElement, this.elementos[indexes[0]].elementos[indexes[1]] )

						var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
						if(foundIndex != -1){
							this.selectedElements[foundIndex].qty = newObjectElement.qty
							if(newObjectElement.qty == 0){
								this.selectedElements.splice(foundIndex,1)
							}
						}
						else{
							this.selectedElements.push(newObjectElement)
						}
						this.countElements()
					}
				}
			},
			plusElementbySearch(el){
				let qty = parseInt(this.$refs[el][0].innerText)
				qty++
				this.$refs[el][0].innerText = qty
				if(qty || qty == ''){
					let indexes = el.split("-")
					let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
					let newObjectElement = Object.assign( newElement, this.searchElements[indexes[1]] )

					var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
					if(foundIndex != -1){
						this.selectedElements[foundIndex].qty = newObjectElement.qty
						if(newObjectElement.qty == 0){
							this.selectedElements.splice(foundIndex,1)
						}
					}
					else{
						this.selectedElements.push(newObjectElement)
					}
					this.countElements()
				}
			},
			minusElementbySearch(el){
				let qty = parseInt(this.$refs[el][0].innerText)
				if(qty > 0){
					qty--
					this.$refs[el][0].innerText = qty
					if(qty || qty == ''){
						let indexes = el.split("-")
						let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
						let newObjectElement = Object.assign( newElement, this.searchElements[indexes[1]] )

						var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
						if(foundIndex != -1){
							this.selectedElements[foundIndex].qty = newObjectElement.qty
							if(newObjectElement.qty == 0){
								this.selectedElements.splice(foundIndex,1)
							}
						}
						else{
							this.selectedElements.push(newObjectElement)
						}
						this.countElements()
					}
				}
			},
			addElement(el){
				let qty = this.$refs[el][0].$refs.input.value
				if(qty == ''){qty = 0}
				if(qty || qty == ''){
					let indexes = el.split("-")
					let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
					let newObjectElement = Object.assign( newElement, this.elementos[indexes[0]].elementos[indexes[1]] )

					var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
					if(foundIndex != -1){
						this.selectedElements[foundIndex].qty = newObjectElement.qty
						if(newObjectElement.qty == 0){
							this.selectedElements.splice(foundIndex,1)
						}
					}
					else{
						this.selectedElements.push(newObjectElement)
					}
					this.countElements()
				}
			},
			addElementbySearch(el){
				let qty = this.$refs[el][0].$refs.input.value
				if(qty == ''){qty = 0}
				if(qty || qty == ''){
					let indexes = el.split("-")
					let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
					let newObjectElement = Object.assign( newElement, {nombre: this.searchElements[indexes[1]].nombre, metros: this.searchElements[indexes[1]].metros})

					var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
					if(foundIndex != -1){
						this.selectedElements[foundIndex].qty = newObjectElement.qty
						if(newObjectElement.qty == 0){
							this.selectedElements.splice(foundIndex,1)
						}
					}
					else{
						this.selectedElements.push(newObjectElement)
					}
					this.countElements()
				}
			},
			addManual(){
				if(this.$refs.formManual.validate()){
					const volume = this.manualElement.alto * this.manualElement.ancho * this.manualElement.largo / 1000000
					const newObjectElement = {
						cat: "Manual",
						escarleraO: false,
						escarleraD: false,
						metros: volume,
						nombre: this.manualElement.descripcion,
						qty: parseInt(this.manualElement.qty),
						valor: parseInt(this.manualElement.valor),
						img: 'https://firebasestorage.googleapis.com/v0/b/duoapp-56ef2.appspot.com/o/elements_flete_img%2Ficonmanual2.png?alt=media&token=e4ef0b0d-6cfc-4962-9e1a-090ebe996456'
					}
					this.selectedElements.push(newObjectElement)
					this.countElements()
					this.$refs.formManual.reset()
					window.scrollTo(0,0)
				}
			},
			removeElement(index){
				this.selectedElements.splice(index,1)
				this.countElements()
			},
			countElements(){
				const here = this
				let counter = 0
				let counterVolume = 0
				this.selectedElements.map(function(item) {
					 counter = counter + item.qty
					 counterVolume = counterVolume + (item.qty*item.metros)
					 counterVolume = Math.round(counterVolume * 100) / 100
				});
				this.counterVolume = counterVolume
				this.totalElements = counter
			},
			goBack(){
				EventBus.$emit('goBackMudanza', 2)
			},
			eventTracker(tipo) {
				gtag('event', tipo, {
				'event_category' : tipo,
				'event_label' : tipo
				})
			}

		},
		watch: {
			searchElements: function(){
				const here = this
	      this.$nextTick(() => {
          here.searchContainerHeight = here.$refs.searchResultContainer.$el.clientHeight
	      });
			},
			showSearch: function(val){
				if(!val){ this.searchContainerHeight = 0 }
			}
		},
		mounted () {			
			let db = firebase.firestore()
			let self = this
			db.collection("elementos").get().then((querySnapshot) => {
				querySnapshot.forEach((doc) => {
					const elementos = doc.data()
					if(!elementos.manual){
						self.elementos.push( elementos )
						elementos.elementos.forEach((elemento) => {
							let data = elemento
							data.cat = elementos.datos.nombre
							self.totalSearchElements.push( data )
						})
					}
					else{
						self.element_manual = doc.data()
					}
				})
				self.elementos.sort(function(a, b) {
					if (a.datos.posicion > b.datos.posicion) {
						return 1;
					}
					if (a.datos.posicion < b.datos.posicion) {
						return -1;
					}
					return 0;
				})
			})
			EventBus.$on('retomarPedidoSecond', data => {
				this.selectedElements = data
				this.countElements()
				EventBus.$emit('avanzarRetomar', {e1: 3})
			})
		}
	}
</script>